module.exports = __webpack_public_path__ + "static/media/knc-graphic.2125d6bd.png";